import React, { useState, useEffect } from 'react';

function PurchaseNotification() {
  const [notifications, setNotifications] = useState([]);

  // Datos de notificaciones simuladas
  const notificationData = [
    { name: 'Sarah M.', location: 'New York, USA', action: 'purchased', product: 'Complete Spanish Learning Bundle', time: '2 minutes ago', flag: 'USA' },
    { name: 'Michael R.', location: 'Los Angeles, USA', action: 'subscribed', product: 'Spanish Through Music Collection', time: '5 minutes ago', flag: 'USA' },
    { name: 'Emma W.', location: 'London, UK', action: 'purchased', product: 'Business Spanish Mastery', time: '8 minutes ago', flag: 'UK' },
    { name: 'David B.', location: 'Toronto, Canada', action: 'subscribed', product: 'Travel Spanish Essentials', time: '12 minutes ago', flag: 'CAN' },
    { name: 'Lisa H.', location: 'Sydney, Australia', action: 'purchased', product: 'Spanish Grammar Bootcamp', time: '15 minutes ago', flag: 'AUS' },
    { name: 'James K.', location: 'Madrid, Spain', action: 'subscribed', product: 'Spanish Conversation Accelerator', time: '18 minutes ago', flag: 'ESP' },
    { name: 'Jennifer F.', location: 'Chicago, USA', action: 'purchased', product: 'Kids Spanish Adventure', time: '22 minutes ago', flag: 'USA' },
    { name: 'Robert R.', location: 'Berlin, Germany', action: 'subscribed', product: 'Spanish Literature and Culture', time: '25 minutes ago', flag: 'GER' },
    { name: 'Maria G.', location: 'Mexico City, Mexico', action: 'purchased', product: 'Spanish Pronunciation Master', time: '30 minutes ago', flag: 'MEX' },
    { name: 'Carlos M.', location: 'Buenos Aires, Argentina', action: 'subscribed', product: 'Spanish for Medical Professionals', time: '35 minutes ago', flag: 'ARG' },
    { name: 'Ana L.', location: 'São Paulo, Brazil', action: 'purchased', product: 'Spanish Cooking and Recipes', time: '40 minutes ago', flag: 'BRA' },
    { name: 'John D.', location: 'Miami, USA', action: 'subscribed', product: 'Spanish Exam Preparation', time: '45 minutes ago', flag: 'USA' },
    { name: 'Sophie T.', location: 'Paris, France', action: 'purchased', product: 'Complete Spanish Learning Bundle', time: '50 minutes ago', flag: 'FRA' },
    { name: 'Luca P.', location: 'Rome, Italy', action: 'subscribed', product: 'Spanish Through Music Collection', time: '55 minutes ago', flag: 'ITA' },
    { name: 'Olivia S.', location: 'Dublin, Ireland', action: 'purchased', product: 'Business Spanish Mastery', time: '1 hour ago', flag: 'IRL' }
  ];

  useEffect(() => {
    // Mostrar primera notificación después de 3 segundos
    const firstTimeout = setTimeout(() => {
      addNotification();
    }, 3000);

    // Agregar nuevas notificaciones cada 8-15 segundos
    const interval = setInterval(() => {
      addNotification();
    }, Math.random() * 7000 + 8000); // Entre 8 y 15 segundos

    return () => {
      clearTimeout(firstTimeout);
      clearInterval(interval);
    };
  }, []);

  const addNotification = () => {
    const randomNotification = notificationData[Math.floor(Math.random() * notificationData.length)];
    const id = Date.now() + Math.random();
    
    setNotifications(prev => [...prev, { ...randomNotification, id }]);

    // Remover notificación después de 5 segundos
    setTimeout(() => {
      setNotifications(prev => prev.filter(notif => notif.id !== id));
    }, 5000);
  };

  return (
    <div className="fixed bottom-6 left-6 z-50 space-y-3 pointer-events-none">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className="bg-white rounded-lg shadow-md p-4 min-w-[280px] max-w-[320px] pointer-events-auto relative"
          style={{
            animation: 'slideInLeft 0.3s ease-out',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
        >
          <div className="flex items-start gap-3">
            {/* Icono circular verde con checkmark */}
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            
            {/* Contenido */}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold text-gray-900 mb-1">
                {notification.name} {notification.action === 'purchased' ? 'comprou' : 'subscribed to'}
              </p>
              <p className="text-sm text-gray-600 mb-1">
                {notification.product}
              </p>
              <p className="text-xs text-gray-400">
                {notification.time}
              </p>
            </div>
            
            {/* Botón cerrar */}
            <button
              onClick={() => setNotifications(prev => prev.filter(notif => notif.id !== notification.id))}
              className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors absolute top-2 right-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      ))}
      <style>{`
        @keyframes slideInLeft {
          from {
            transform: translateX(-110%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default PurchaseNotification;

